/* TWRD country lists, built on demand (html-lite change 1).
   Source: <script type="application/json" id="twrd-countries-data"> printed once
   by snippets/twrd-country-data.liquid. Targets: the empty <ul class="list-menu">
   inside #Details-DrawerCountrySelector and #Details-FooterCountrySelector.
   The country name arrives from Liquid already HTML-escaped (Shopify gives
   "Bosnia &amp; Herzegovina"), exactly as the old markup printed it, so it is
   inserted as is. The row markup is byte for byte what Liquid printed before, so theme CSS and
   localize-form.js see no difference. */
(function () {
  'use strict';
  if (window.__twrdCountryLazy) return;
  window.__twrdCountryLazy = true;

  var SELECTOR = '#Details-DrawerCountrySelector, #Details-FooterCountrySelector';
  var rows = null;

  function esc(text) {
    return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function load() {
    if (rows) return rows;
    rows = [];
    var node = document.getElementById('twrd-countries-data');
    if (!node) return rows;
    try {
      rows = JSON.parse(node.textContent) || [];
    } catch (err) {
      if (window.console && console.warn) console.warn('[twrd-country]', err);
    }
    return rows;
  }

  function build(current) {
    var out = '';
    var list = load();
    for (var i = 0; i < list.length; i++) {
      var row = list[i];
      var active = row[0] === current;
      out +=
        '<li class="list-menu__item' + (active ? ' list-menu__item--active' : '') + '">\n' +
        '<a href="#" class="list-menu__link js-localize-item"' + (active ? ' aria-current="true"' : '') +
        ' data-value="' + esc(row[0]) + '">\n' +
        '<span class="list-menu__text">' + row[1] + '\n' +
        '<span class="localization-form__country">(' + esc(row[2]) + '\n' + esc(row[3]) + ')</span></span>\n' +
        '</a>\n</li>';
    }
    return out;
  }

  function stamp(details) {
    if (!details || details.getAttribute('data-twrd-country-ready') === 'true') return;
    var form = details.querySelector('localize-form');
    var ul = form && form.querySelector('ul.list-menu');
    var input = form && form.querySelector('input[data-localize-input]');
    if (!ul || !input) return;
    if (!load().length) return;
    details.setAttribute('data-twrd-country-ready', 'true');
    ul.innerHTML = build(input.value);
    /* localize-form binds its click handlers on connect. The rows are new, so
       bind them now. Not defined yet means the upgrade will bind them. */
    if (typeof form.connectedCallback === 'function') form.connectedCallback();
  }

  function stampAll() {
    var all = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < all.length; i++) stamp(all[i]);
  }

  function owner(target) {
    return target && target.closest ? target.closest(SELECTOR) : null;
  }

  /* Hover, touch, focus or a click on the toggle builds the list before it opens. */
  ['pointerover', 'touchstart', 'pointerdown', 'focusin', 'click', 'keydown'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var details = owner(event.target);
      if (details) stamp(details);
    }, { capture: true, passive: true });
  });

  /* Safety nets: a details opened by script, and the drawer once it is open. */
  document.addEventListener('toggle', function (event) {
    var details = owner(event.target);
    if (details) stamp(details);
  }, true);
  /* The menu drawer sends on:modal:opened when its slide has ended (a11y-dialog
     waits for the content animations). Building here, not on the trigger
     click, keeps the ~250 rows out of the slide frames. The event does not
     bubble, so listen in the capture phase. The country <details> is closed,
     and a touch, hover or focus on it still builds the list at once (above),
     so the list is ready before a user can open it. */
  document.addEventListener('on:modal:opened', function (event) {
    if (!event.target || event.target.id !== 'modal-main-menu') return;
    if ('requestIdleCallback' in window) requestIdleCallback(stampAll, { timeout: 1200 });
    else setTimeout(stampAll, 300);
  }, true);
  document.addEventListener('shopify:section:load', stampAll);
})();
